<template>
  <div class="msgTxt bg-white p-3">
     <vs-row vs-justify="flex-end">
         <!-- <p>Inside File Container</p> -->
      <span v-if="message.message_time" style="width:100%;font-size:10px;">{{message.sender_user_details.first_name}} {{message.sender_user_details.last_name}} &nbsp; {{ message.message_time | moment('h:mm a') }}</span>
    </vs-row>
    <vs-row>
      <!-- {{message.message}}
      {{message.attachment_type}} -->
      <div class="chat-file-type" style="white-space: pre-line">
        
          <div class="" v-if="getAssignmentType(message.attachment_type) === 'image'">
            <a :href="message.message" download target="_blank"> 
            <img
            :src="message.message"
            style="max-width:100%">
            </a>
          </div>

          <div class="" v-if="getAssignmentType(message.attachment_type) === 'video'">
            <a :href="message.message" download target="_blank">
            <i class="material-icons" style="color:crimson">ondemand_video</i>
            </a>
          </div>
          
          <div class="" v-if="getAssignmentType(message.attachment_type) === 'audio'">
            <a :href="message.message" download target="_blank">
            <i class="material-icons" style="color:burlywood">audiotrack</i>
            </a>
          </div>
          
          <div class="" v-if="getAssignmentType(message.attachment_type) === 'doc'">
            <a :href="message.message" download target="_blank">
              <i class="material-icons" style="color:teal" v-if="message.attachment_type === 'pdf'">picture_as_pdf</i>


              <svg v-else-if="message.attachment_type === 'doc' || message.attachment_type === 'docx'" 
              xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
              width="40" height="40"
              viewBox="0 0 172 172"
              style=" fill:#000000;"><g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path d="M0,172v-172h172v172z" fill="none"></path><g fill="#9b59b6"><path d="M86,21.5l-71.66667,14.33333v100.33333l71.66667,14.33333zM100.33333,35.83333v14.33333h43v14.33333h-43v14.33333h43v14.33333h-43v14.33333h43v14.33333h-43v14.33333h50.16667c3.956,0 7.16667,-3.21067 7.16667,-7.16667v-86c0,-3.956 -3.21067,-7.16667 -7.16667,-7.16667zM23.61361,59.44694h11.00195l3.52734,24.92937c0.25083,1.49783 0.44657,3.5382 0.50391,6.06087h0.18197c0.05733,-1.84183 0.31869,-3.94335 0.75586,-6.20085l4.52116,-24.78939h13.39551l4.18522,24.70541c0.25083,1.29716 0.42955,3.20361 0.61589,5.66894h0.13997c0.05733,-1.9135 0.24624,-3.89923 0.48991,-5.94889l3.42936,-24.42546h10.34408l-9.91016,53.10612h-9.42025l-6.29883,-28.38672c-0.31533,-1.77017 -0.48823,-3.76307 -0.5599,-5.9489h-0.12598c-0.129,2.38651 -0.37771,4.37223 -0.68587,5.9489l-6.4248,28.38672h-9.79818z"></path></g></g></svg>

              
              <img v-else-if="message.attachment_type === 'txt'" src="data:image/png;base64,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"/>


              <i v-else class="material-icons" style="color:teal">assessment</i>
              </a>
          </div>

          <div class="" v-if="getAssignmentType(message.attachment_type) === 'other'">
            <a :href="message.message" download target="_blank">
            <i class="material-icons" style="color:teal">assessment</i>
            </a>
          </div>
      </div>
    </vs-row>
   
  </div>
</template>
<script>
import {messageMixin} from './mixin/messageMixin'
import {mapGetters} from 'vuex'

export default {
  name: 'messageTextContainer',
  props:  {
    message: {
      type:Object,
      required:true,
      default:() => {}
    }
  },
  data () {
    return {  
      image_type_arr: ['.tiff', '.pjp', '.jfif', '.gif', '.svg', '.bmp', '.png', '.jpeg', '.svgz', '.jpg', '.webp', '.ico', '.xbm', '.dib', '.tif', '.pjpeg', '.avif'],

      video_type_arr : ['.ogm', '.wmv', '.mpg', '.webm', '.ogv', '.mov', '.asx', '.mpeg', '.mp4', '.m4v', '.avi'],

      audio_type_arr : ['.opus', '.flac', '.webm', '.weba', '.wav', '.ogg', '.m4a', '.mp3', '.oga', '.mid', '.amr', '.aiff', '.wma', '.au', '.aac'],

      doc_type_arr : ['.xlsx', '.xls', '.doc', '.docx', '.ppt', '.pptx', '.txt', '.pdf']
    }
  },
  mixin:[messageMixin],
  computed: {
    ...mapGetters(['UserActiveThread', 'ClientActiveThread', 'GroupActiveThread', 'tabActive'])
  },
  mounted () {
    
  },
  methods: {
    getAssignmentType (attachment_type) {
      //Adding . (dot) to make it extension type to check in respespective file type array 
      attachment_type = `.${attachment_type}`
      const type = this.image_type_arr.includes(attachment_type) ? 'image' : this.video_type_arr.includes(attachment_type) ? 'video' : this.audio_type_arr.includes(attachment_type) ? 'audio' : this.doc_type_arr.includes(attachment_type) ? 'doc' : 'other' 
      return type
    }

  }
}
</script>
<style scoped>
.msgTxt {
  position: relative;
  min-height:50px;
  max-width:70%;
  min-width:10%;
  border-radius: 10px;
}

.delete-msg{
  position: absolute;
  top: 26px;
  right: -30px;
}

.chat-file-type i{
    font-size: 40px;
}
</style>
